import React from "react";
import ReactDOM from "react-dom/client";
import style from "./index.module.css";
import App from "./App.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
//טקסט להעתקה
{
  /* <p className={style.description}>
I am a frontend developer with 3 years of experience in designing,
developing, and maintaining diverse web applications. I have
hands-on experience with various technologies and a proven ability
to solve complex problems effectively.
</p>
<p className={style.description}>
As a dedicated team player, I am passionate about innovation and
continually learning new skills. I excel in creating efficient,
high-quality solutions while maintaining a strong commitment to
self-improvement.
</p>
<p className={style.description}>
My high level of sociability, quick integration into teams, and
drive for professionalism make me a valuable asset to any
organization. I am eager to contribute and grow as part of a dynamic
and forward-thinking team.
</p> */
}
